import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u704621842/domains/plenari.cat/hbuilds/source/repository/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/u704621842/domains/plenari.cat/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
